import {
  Component,
  DestroyRef,
  EventEmitter,
  OnInit,
  inject,
} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {
  AlertType,
  GlobalAlert,
  MultiLanguageValue,
} from '../../../models/GlobalAlert';
import {UserManagementService} from '../../../services/user-management.service';
import {TranslateService} from '@ngx-translate/core';
import {UserService} from '../../../services/user.service';

@Component({
  selector: 'app-global-alert',
  templateUrl: './global-alert.component.html',
  styleUrls: ['./global-alert.component.scss'],
  standalone: false,
})
export class GlobalAlertComponent implements OnInit {
  private readonly userManagementService = inject(UserManagementService);
  private readonly userService = inject(UserService);
  private readonly translateService = inject(TranslateService);
  private readonly destroyRef = inject(DestroyRef);

  alerts: GlobalAlert[] = [];
  currentLanguage = this.translateService.currentLang || 'en';
  dismiss = new EventEmitter<GlobalAlert>();

  async ngOnInit() {
    this.userService.userDataChange.subscribe(async (user) => {
      if (user) {
        this.alerts = await this.userManagementService.loadAlertList();
      }
    });

    this.translateService.onLangChange
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((event) => {
        this.currentLanguage = event.lang;
      });
  }

  getTitle(alert: GlobalAlert): string {
    return this.getLocalizedValue(alert.title, this.currentLanguage);
  }

  getDescription(alert: GlobalAlert): string {
    return this.getLocalizedValue(alert.description, this.currentLanguage);
  }

  getLocalizedValue(
    values: MultiLanguageValue[] | undefined,
    language: string,
  ): string {
    if (!values || values.length === 0) {
      return '';
    }
    const found = values.find((v) => v.language === language);
    return found?.value ?? values[0].value;
  }

  async onDismiss(alert: GlobalAlert) {
    if (alert.type === AlertType.SINGLE) {
      await this.userManagementService.dismissAlert(alert.id);
    }
  }
}
